module.exports = __webpack_public_path__ + "img/ic_picto_map_pharma_provider.8492caf1.svg";